import React from 'react';

export function CustomLoader() {
    return (
        <div className='loading_section-main'>
            <div className='loading_section'>
                <img width={'100px'} alt="loading" src={`${process.env.PUBLIC_URL}/assets/svg/loader.svg`} />
            </div>
        </div>
    );
}
